const DELIVERY_PARTNER_CATEGORY_ID = 47

export const RIDER_PROFILE_TAB_PARENT_PERMISSIONS = {
  view_rider_documents: ["delivery_partners_4"],
  view_rider_earnings: ["delivery_partners_6"],
  view_rider_payments: ["delivery_partners_6", "delivery_partners_7"],
  view_rider_location: ["delivery_partners_5"],
}

export const getDeliveryPartnerPermissionGroup = userRole =>
  userRole?.permissions?.find(group => Number(group?.id) === DELIVERY_PARTNER_CATEGORY_ID)

export const isDeliveryPartnerPermissionEnabled = (userRole, permissionId) => {
  const permission = getDeliveryPartnerPermissionGroup(userRole)?.permissions?.find(
    entry => entry.id === permissionId
  )
  return Boolean(permission?.isEnabled)
}

export const getRiderProfileSubPermissions = userRole => {
  const viewPermission = getDeliveryPartnerPermissionGroup(userRole)?.permissions?.find(
    entry => entry.id === "delivery_partners_1"
  )

  if (!Array.isArray(viewPermission?.subPermissions) || viewPermission.subPermissions.length === 0) {
    return null
  }

  return viewPermission.subPermissions.reduce((acc, subPermission) => {
    const requiredParents = RIDER_PROFILE_TAB_PARENT_PERMISSIONS[subPermission.id]
    const parentAllowed =
      !requiredParents ||
      requiredParents.some(parentId =>
        isDeliveryPartnerPermissionEnabled(userRole, parentId)
      )

    acc[subPermission.id] = {
      ...subPermission,
      isEnabled: Boolean(subPermission.isEnabled && parentAllowed),
    }
    return acc
  }, {})
}

export const buildDeliveryPartnerPermissions = userRole => ({
  view: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_1"),
  addUpdate: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_2"),
  delete: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_3"),
  documents: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_4"),
  location: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_5"),
  earnings: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_6"),
  bank: isDeliveryPartnerPermissionEnabled(userRole, "delivery_partners_7"),
})
